import React from "react"
import {FieldEditableMode, FieldEditableProps} from "../../../proto/render/editable";
import {FieldViewSize} from "../../../const";
import AttachmentsManager from "../../../../gd-components/files/attachments-manager/attachments-manager";
import {AttachFileMode} from "../../../../gd-components/files/const";
import AttachmentsCollection from "../../../../model2/attachment/attachments";
import ControlButtonStandard, {
    ControlButtonType
} from "../../../../gd-components/buttons/control-button/control-button-standard";
import Attachment from "../../../../model2/attachment/attachment";
import {FieldInlineEditableProps} from "../../../render/inline-editable";
import ApiAttachment from "../../../../gd/api/attachment";
import {AttachmentSystemType} from "../../../../model2/attachment/@types";

// const debug = "FieldAttachment_InlineEditable"
const debug = false

type State = {
    mode                : FieldEditableMode

    initialPropsValue   : any
    currentValue        : any
}

export default class FieldAttachment_InlineEditable extends React.Component<FieldInlineEditableProps,State> {

    public previousValue        : any
    public attachmentsRef = React.createRef<any>();
    public domElementId         : ID
    public loading              : boolean

    public static defaultProps  = {
        size        : FieldViewSize.DEFAULT
    }

    constructor(props:FieldEditableProps) {
        super(props);

        this.domElementId = "item-" + gd.utils.generateUIDWithCollisionChecking()
        this.loading      = false

        const value = props.field.getViewValue(props.model)

        debug && console.log(debug,"constructor initValue=", value)

        this.state = {
            mode                : FieldEditableMode.VIEW,
            initialPropsValue   : value, // required to check if currentOption update needed on props changed
            currentValue        : value,
        }
    }

    static getDerivedStateFromProps(props:any, state:any) {

        // const newValue = props.model[props.field.fieldId]
        const newValue = props.field.getViewValue(props.model)

        debug && console.log(debug, "getDerivedStateFromProps newValue=", newValue)

        if (newValue !== state.initialPropsValue) {

            debug && console.log(debug, "props have changed - apply to state and set initialPropsValue")

            return {
                initialPropsValue   : newValue,
                currentValue        : newValue
            }
        }
        return null
    }

    get classes():string {

        // min-w-80 -needed in editable like project info

        const classes = Classes("ui5-field-editable w-300", this.props.className, {
            "ui5-txt-default"               : this.props.size === FieldViewSize.DEFAULT,
            "size-default"                  : this.props.size === FieldViewSize.DEFAULT,
            "ui5-txt-less-important-small"  : this.props.size === FieldViewSize.SMALL,
            "size-small"                    : this.props.size === FieldViewSize.SMALL,
        })
        return classes
    }

    onValueChange = (value: AttachmentsCollection) => {

        if(value.isEmpty){
            this.setState({mode: FieldEditableMode.HOVERED})
            this.loading = false
        }

        if (this.props.onChange) {
            // @ts-ignore
            this.props.onChange(value.singleAttachment, this.onCancelChange);
        }
    }

    onSelect = (e:React.SyntheticEvent) => {

        const attachment = this.props.field.getViewValue(this.props.model)

        if(attachment) return

        e.stopPropagation()

        this.attachmentsRef.current.resetAttachments()
        this.attachmentsRef.current.selectAttachment("local")
        this.setState({mode: FieldEditableMode.HOVERED})
    }

    onCancelChange = () => {
        this.setState({
            currentValue: this.previousValue
        });
    }

    onMouseEnter = () => {

        if(this.loading) return

        if (!this.canEdit) return

        if (this.state.mode === FieldEditableMode.VIEW) this.setState({
            mode   : FieldEditableMode.HOVERED
        })
    }

    onMouseLeave = () => {

        if(this.loading) return

        if (this.state.mode === FieldEditableMode.HOVERED) {
            this.setState({
                mode        : FieldEditableMode.VIEW
            })
        }
    }

    get canEdit():boolean {

        const canEdit = this.props.field.canEdit(this.props.model)

        return canEdit;

    }

    startLoading = ()=>{
        this.loading = true
    }

    finishLoading = (attachment: Attachment)=>{
        this.loading = false
        ApiAttachment.save([attachment])
    }

    render() {

        let classes = ""

        switch (this.state.mode) {
            case FieldEditableMode.HOVERED:
                classes= Classes(this.classes, "is-hovered", "h-36");
                break

            case FieldEditableMode.VIEW:
            default:
                classes = Classes(this.classes, "h-36")
        }

        const mode = this.canEdit ? AttachFileMode.VIEW_AND_EDIT_SMALL : AttachFileMode.VIEW_SMALL

        const attachment = this.props.field.getViewValue(this.props.model)

        const attachmentsCollection: AttachmentsCollection = attachment ?
            new AttachmentsCollection([attachment])              :
            new AttachmentsCollection([])

        return (
            <div id           = {this.domElementId}
                 className    = {classes}
                 onClick      = {this.onSelect}
                 onMouseEnter = {this.onMouseEnter}
                 onMouseLeave = {this.onMouseLeave}>

                <AttachmentsManager ref                   = {this.attachmentsRef}
                                    mode                  = {mode}
                                    systemType            = {AttachmentSystemType.CUSTOM}
                                    onlySingleFile        = {true}
                                    className             = "single-item w-100-percent"
                                    attachmentsCollection = {attachmentsCollection}
                                    dropzoneDOMElementId  = {this.domElementId}
                                    onNewUploadStarted    = {this.startLoading}
                                    saveNewUpload         = {this.finishLoading}
                                    onChange              = {this.onValueChange}/>

                {this.state.mode === FieldEditableMode.HOVERED && _.isEmpty(attachment) && (
                    <div className="buttons">
                        <ControlButtonStandard className = "btn-add"
                                               type      = {ControlButtonType.PLUS}
                                               hint      = "Add file"
                                               onClick   = {this.onSelect} size={24}/>
                    </div>
                )}
            </div>
        )
    }
}
